import Vue from 'vue';

import Antd from 'ant-design-vue';
import Notification from 'ant-design-vue';
import Spin from 'ant-design-vue';
import 'ant-design-vue/dist/antd.less';

import App from './App.vue';

import router from './router';
import store from './store';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';

import Notify from '@shared/mixins/notify.mixins';
import Spinner from '@shared/mixins/spinner.mixins';
import cancelRequest from '@shared/mixins/cancelRequest.mixins';

import TimeText from '@shared/filters/time-text.filter';
import TimeStringFilter from '@shared/filters/time-string.filter';
import DateStringFilter from '@shared/filters/date-string.filter';
import Lowercase from '@shared/filters/lowercase.filter';
import Uppercase from '@shared/filters/uppercase.filter';
import Capitalize from '@shared/filters/capitalize.filter';

import { PrivateLayout, PublicLayout } from './layouts';

import Unauthorized from '@shared/components/Unauthorized.vue';
import PageNotFound from '@shared/components/PageNotFound.vue';
import Transfer from '@shared/components/Transfer.vue';

import ApiService from '@shared/services/api.service';
import JwtService from '@shared/services/jwt.service';

import LazyLoadImgDirective from '@shared/directives/LazyLoadImgDirective';
import ScrollToInvalidFieldDirective from '@shared/directives/ScrollToInvalidField';
import ResizeElementObserver from '@shared/directives/ResizeElementObserver';

Vue.config.productionTip = false;
// Vue.config.devtools = true;
Vue.config.devtools = false;

Vue.use(Antd);
Vue.use(Notification);
Vue.use(Spin);
Vue.use(Notify);
Vue.use(cancelRequest);
Vue.use(VueLodash, { name: 'custom', lodash: lodash });
Vue.mixin(Spinner);
Vue.filter('timeText', TimeText);
Vue.filter('timeString', TimeStringFilter);
Vue.filter('dateString', DateStringFilter);
Vue.filter('lowercase', Lowercase);
Vue.filter('uppercase', Uppercase);
Vue.filter('capitalize', Capitalize);
ApiService.init();

Vue.component('private', PrivateLayout);
Vue.component('public', PublicLayout);
Vue.component('unauthorized', Unauthorized);
Vue.component('page-not-found', PageNotFound);
Vue.component('transfer', Transfer);
Vue.component('Spinner', () => import('@shared/components/Spinner.vue'));
Vue.component('PaginationBar', () => import('@shared/components/PaginationBar.vue'));
Vue.component('Checkbox', () => import('@shared/components/Checkbox.vue'));
Vue.component('PaginationTable', () => import('@shared/components/PaginationTable.vue'));

Vue.directive('lazyLoadImg', LazyLoadImgDirective);
Vue.directive('scrollToInvalidField', ScrollToInvalidFieldDirective);
Vue.directive('resize', ResizeElementObserver);

const app = new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');

app.$notification.config({
  placement: 'topRight',
  bottom: '0',
  duration: 3
});

Vue.axios.interceptors.request.use(
  (config) => {
    if (config.url === '/login') {
      return config;
    }
    let token = JwtService.getToken();

    if (app.$store.state.user.token) {
      token = app.$store.state.user.token;
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

Vue.axios.interceptors.response.use(
  (response) => {
    app.hideLoading();
    return response;
  },
  (error) => {
    const statusErrorCode = error.response && error.response.status && !isNaN(error.response.status) && +error.response.status;
    let flattenErrMessages = [];
    const isLoginPage = error.response && error.response.config && error.response.config.url === '/login';
    if (!Vue.axios.isCancel(error) && statusErrorCode === 401 && !isLoginPage) {
      app.$router.push('/login');
    }
    const errMessages = (error.response && error.response.data && error.response.data.errors && Object.values(error.response.data.errors)) || [];
    flattenErrMessages = [].concat.apply([], ...errMessages);
    const originErrorMessages = (error.response && error.response.data && error.response.data.message) || '';
    if (originErrorMessages && !flattenErrMessages.length) {
      flattenErrMessages.push(originErrorMessages);
    }
    app.hideLoading();
    if (!flattenErrMessages.length) {
      flattenErrMessages.push('HTTP error received from web server.');
    }
    const errorFormatModel = {
      status: statusErrorCode,
      messages: flattenErrMessages,
      response: error.response
    };
    return !Vue.axios.isCancel(error) ? Promise.reject(errorFormatModel) : Promise.reject(error);
  }
);
